import { TranslationAction } from './types';

/*
 * This diff is merged into the translations and the translation-interface for local development.
 *
 * If you want them to become "productive":
 * - You can update them manually in the POEditor-Interface or via API request (`pnpm pushTranslations`)
 * - You set it back to an empty array if finished successfully
 *
 */
export const diff: TranslationAction[] = [
  {
    newTermWithContext: 'TaskTypeDescriptionEnum.TrackItImport',
    translation: 'Track-it Measurement Import',
  },
  {
    newTermWithContext: 'TrackItOriginalName',
    translation: 'Original Track-it name',
  },
  {
    newTermWithContext: 'TrackItShowNames',
    translation: 'Show Track-it names',
  },
  {
    newTermWithContext: 'TrackItContextBarText',
    translation:
      'Field names and units below carry hints showing what they were called in your pre-configured Track-it installation.',
  },
  {
    newTermWithContext: 'TrackItMappingOverview',
    translation: 'Track-it mapping overview',
  },
  {
    newTermWithContext: 'TrackItMappingOverviewDescription',
    translation:
      'Deterministic mappings derived from your pre-configured Track-it installation. Any user-defined values are resolved later, when an import is processed.',
  },
  {
    newTermWithContext: 'TrackItNoMappedParameters',
    translation: 'No Track-it-mapped parameters in this target area yet.',
  },
  {
    newTermWithContext: 'TrackItUnmapped',
    translation: 'unmapped',
  },
  {
    newTermWithContext: 'TrackItUnmappedHint',
    translation: 'No Track-it mapping for this field.',
  },
  {
    newTermWithContext: 'TrackItFilters',
    translation: 'Track-it data',
  },
  {
    newTermWithContext: 'SelectTrackItFilters',
    translation: 'Select Track-it data',
  },
  {
    newTermWithContext: 'SelectTrackItFilter',
    translation: 'Select Track-it data',
  },
  {
    newTermWithContext: 'SelectExisting',
    translation: 'Select existing',
  },
  {
    newTermWithContext: 'TrackItFiltersDescription',
    translation:
      'Select the measurement parameters and properties used to identify the matching Track-it measurements during job execution. Choose the required parameters from the list.',
  },
  {
    newTermWithContext: 'NoTrackItFiltersSelected',
    translation:
      'Select the measurement parameters and properties used in Track-it for this task.\nThis selection can be configured in each setup combination to find matching Track-it measurements in the job execution.',
  },
  {
    newTermWithContext: 'TrackItMeasurementParameter',
    translation: { one: 'Measurement parameter', other: 'Measurement parameters' },
  },
  {
    newTermWithContext: 'SuggestTrackItParameters',
    translation: 'Suggest',
  },
  {
    newTermWithContext: 'TrackItRecommendationsAddedMessage',
    translation:
      'Suggested measurement parameters were added to your selection. Review them before applying.',
  },
  {
    newTermWithContext: 'TrackItMeasuringProperty',
    translation: { one: 'Property', other: 'Properties' },
  },
  {
    newTermWithContext: 'TrackItMatchingMeasurements',
    translation: 'Matching measurements',
  },
  {
    newTermWithContext: 'ShowMatchingMeasurements',
    translation: 'Show measurements',
  },
  {
    newTermWithContext: 'TrackItIgnoreInImport',
    translation: 'Ignore in import',
  },
  {
    newTermWithContext: 'TrackItFilter',
    translation: 'Track-it filter',
  },
  {
    newTermWithContext: 'TrackItDataTypeId',
    translation: 'Data type id',
  },
  {
    newTermWithContext: 'TrackItFilterValue',
    translation: 'Track-it filter value',
  },
  {
    newTermWithContext: 'True',
    translation: 'True',
  },
  {
    newTermWithContext: 'False',
    translation: 'False',
  },
  {
    newTermWithContext: 'SetupCombinationsUpdateFailedMessage',
    translation:
      'The update could not be completed. Please check the entered values and try again.',
  },
  {
    newTermWithContext: 'TrackItPropertyValueRequiredMessage',
    translation:
      'Track-it property values are still empty. Enter the device/software values in the combinations below — they are required unless marked "Ignore in import".',
  },
  {
    newTermWithContext: 'TrackItRemovalDeletesValuesWarning',
    translation:
      'Removing {{names}} will delete values already entered in individual combinations.',
  },
  {
    newTermWithContext: 'UndoRemoval',
    translation: 'Undo removal',
  },
  {
    newTermWithContext: 'Import',
    translation: 'Import',
  },
  {
    newTermWithContext: 'SelectTrackItMeasurement',
    translation: 'Select Track-it measurement',
  },
  {
    newTermWithContext: 'MeasurementDate',
    translation: 'Measurement date',
  },
  {
    newTermWithContext: 'ImportDate',
    translation: 'Import date',
  },
  {
    newTermWithContext: 'MeasurementDevice',
    translation: 'Measurement device',
  },
  {
    newTermWithContext: 'MeasurementSoftware',
    translation: 'Measurement software',
  },
  {
    newTermWithContext: 'EnterValue',
    translation: 'Enter value',
  },
  {
    newTermWithContext: 'ManuallyEnteredValue',
    translation: 'Manually entered value',
  },
  {
    newTermWithContext: 'TrackItNoMeasurementsInJobTimeFrame',
    translation: "No matching measurements found within the job's time frame.",
  },
  {
    newTermWithContext: 'TrackItNoMatchingMeasurements',
    translation: 'No matching measurements found.',
  },
  {
    newTermWithContext: 'ImportUser',
    translation: 'Import user',
  },
  {
    newTermWithContext: 'TrackItAlias',
    translation: 'Radiation unit',
  },
  {
    newTermWithContext: 'TrackItMeasurementData',
    translation: 'Measurement data',
  },
  {
    newTermWithContext: 'TrackItShowGraphics',
    translation: 'Show graphics',
  },
  {
    newTermWithContext: 'TrackItPosition',
    translation: 'Position',
  },
  {
    newTermWithContext: 'TrackItNoMeasurementData',
    translation: 'This measurement carries no measurement data.',
  },
  {
    newTermWithContext: 'TrackItDownloadFile',
    translation: 'Download',
  },
  {
    newTermWithContext: 'P41AddonTrackItMeasurementImport',
    translation: '[PTW100] Track-it Measurement Import v1',
  },
  {
    newTermWithContext: 'ImportedMeasurements',
    translation: 'Imported measurements',
  },
  {
    newTermWithContext: 'ImportedMeasurementsDescriptionMsg',
    translation: 'View all measurements imported from Track-it.',
  },
  {
    newTermWithContext: 'ImportedMeasurement',
    translation: 'Imported measurement',
  },
  { newTermWithContext: 'AddCondition', translation: 'Add condition' },
  { newTermWithContext: 'AddEvaluationScope', translation: 'Add evaluation scope' },
  { newTermWithContext: 'AppliedForCombinations', translation: 'Applied for combinations' },
  { newTermWithContext: 'Condition_other', translation: 'Conditions' },
  {
    newTermWithContext: 'ConditionCannotBeEditedMsg',
    translation: 'This condition cannot be edited here. Replace it to define a new one.',
  },
  { newTermWithContext: 'EvaluationLabel.DefaultEvaluationScopeName', translation: 'Evaluation' },
  { newTermWithContext: 'Operator', translation: 'Operator' },
  { newTermWithContext: 'ReplaceCondition', translation: 'Replace condition' },
  {
    newTermWithContext: 'UnmatchedCombinations',
    translation: 'Combinations not matched by any evaluation scope',
  },
  {
    newTermWithContext: 'Validation.ConditionParameterNotApplicable',
    translation: 'The condition uses a setup parameter that is no longer part of the setup.',
  },
  {
    newTermWithContext: 'Validation.InvalidPublicationDate',
    translation: 'Please enter a valid calendar date.',
  },
  {
    newTermWithContext: 'Validation.MinutesOutOfRange',
    translation: 'Minutes must be between 0 and 59.',
  },
  {
    newTermWithContext: 'EvaluationLimitsHint',
    translation:
      'Enter the limits to be applied during the job execution to evaluate the measurement results.',
  },
  {
    newTermWithContext: 'EnumerationEvaluationHint',
    translation: 'Assign an evaluation result to an enumeration item.',
  },
  {
    newTermWithContext: 'InstructionForTaskExecution',
    translation: 'Instruction for task execution',
  },
  {
    newTermWithContext: 'Text',
    translation: { one: 'Text', other: 'Texts' },
  },
  {
    newTermWithContext: 'QuantitiesAndUnitsDescriptionMsg',
    translation: 'Manage quantities, enumerations, texts and units.',
  },
  {
    newTermWithContext: 'TextNotUsedInSetupsMsg',
    translation: 'This text is not used in setups.',
  },
  {
    newTermWithContext: 'AdditionalDoseRates',
    translation: 'Additional dose rates',
  },
  {
    newTermWithContext: 'SavedLetEmptyToKeep',
    translation: 'Saved - Let empty to keep',
  },
  {
    newTermWithContext: 'AddMeasurementParameters',
    translation: 'Add measurement parameters',
  },
  {
    newTermWithContext: 'TrackItAddMeasurementParametersHint',
    translation:
      'If a required parameter is not available in the list, add it manually. Enter the parameter name, value type, and unit exactly as defined in Track-it, including spelling and capitalization.',
  },
];
